import React from 'react';
import { Card, CardContent, CardHeader, Grid, Typography, Box } from '@mui/material';
import { useDataProvider } from 'react-admin';
import { useState, useEffect } from 'react';
import InventoryIcon from '@mui/icons-material/Inventory';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import WarningIcon from '@mui/icons-material/Warning';
import StarIcon from '@mui/icons-material/Star';

const StatCard = ({ title, value, icon, color = 'primary' }) => (
  <Card sx={{ height: '100%' }}>
    <CardContent>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Box>
          <Typography color="textSecondary" gutterBottom variant="overline">
            {title}
          </Typography>
          <Typography variant="h4" component="h2">
            {value}
          </Typography>
        </Box>
        <Box color={`${color}.main`}>
          {icon}
        </Box>
      </Box>
    </CardContent>
  </Card>
);

export const Dashboard = () => {
  const dataProvider = useDataProvider();
  const [stats, setStats] = useState({
    totalProducts: 0,
    lowStockProducts: 0,
    featuredProducts: 0,
    totalValue: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const { data: products } = await dataProvider.getList('products', {
          pagination: { page: 1, perPage: 1000 },
          sort: { field: 'id', order: 'ASC' },
          filter: {},
        });

        const totalProducts = products.length;
        const lowStockProducts = products.filter(p => p.stock < 10).length;
        const featuredProducts = products.filter(p => p.featured).length;
        const totalValue = products.reduce((sum, p) => sum + (p.price * p.stock), 0);

        setStats({
          totalProducts,
          lowStockProducts,
          featuredProducts,
          totalValue: Math.round(totalValue),
        });
      } catch (error) {
        console.error('Erreur lors du chargement des statistiques:', error);
      }
    };

    fetchStats();
  }, [dataProvider]);

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Tableau de Bord - MyAdmin
      </Typography>
      <Typography variant="subtitle1" color="textSecondary" gutterBottom>
        La Ferme À L'Ancienne - Gestion des produits
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Total Produits"
            value={stats.totalProducts}
            icon={<InventoryIcon fontSize="large" />}
            color="primary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Stock Faible"
            value={stats.lowStockProducts}
            icon={<WarningIcon fontSize="large" />}
            color="warning"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Produits Vedettes"
            value={stats.featuredProducts}
            icon={<StarIcon fontSize="large" />}
            color="secondary"
          />
        </Grid>
        <Grid item xs={12} sm={6} md={3}>
          <StatCard
            title="Valeur Stock (€)"
            value={`${stats.totalValue.toLocaleString()}`}
            icon={<TrendingUpIcon fontSize="large" />}
            color="success"
          />
        </Grid>
      </Grid>

      <Grid container spacing={3} sx={{ mt: 3 }}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Actions Rapides" />
            <CardContent>
              <Typography variant="body2" color="textSecondary">
                • Ajouter un nouveau produit
              </Typography>
              <Typography variant="body2" color="textSecondary">
                • Vérifier les stocks faibles
              </Typography>
              <Typography variant="body2" color="textSecondary">
                • Gérer les produits vedettes
              </Typography>
              <Typography variant="body2" color="textSecondary">
                • Exporter la liste des produits
              </Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardHeader title="Informations Système" />
            <CardContent>
              <Typography variant="body2" color="textSecondary">
                Version MyAdmin: 1.0.0
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Dernière mise à jour: {new Date().toLocaleDateString('fr-FR')}
              </Typography>
              <Typography variant="body2" color="textSecondary">
                Statut: Opérationnel
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};